const alerts = () => {
  const list = document.querySelector(".alert-list");
  const items = document.querySelectorAll(".alert");
  let count = items.length;

  const closeAlert = (item) => {
    item.remove();
    count--;
    if (count === 0) {
      list.classList.add("is-empty");
    }
  };

  const isSameWebsite = document.referrer.startsWith(window.location.origin);
  if (!isSameWebsite) {
    localStorage.setItem("closedAlerts", JSON.stringify([]));
  }

  const closedAlerts = JSON.parse(localStorage.getItem("closedAlerts")) || [];
  for (const id of closedAlerts) {
    const item = document.querySelector(`.alert[data-id="${id}"]`);
    if (item) {
      closeAlert(item);
    }
  }

  for (const item of items) {
    const id = item.getAttribute("data-id");
    const close = item.querySelector(".alert-close");
    close.addEventListener("click", () => {
      const closedAlerts =
        JSON.parse(localStorage.getItem("closedAlerts")) || [];
      closedAlerts.push(id);
      localStorage.setItem("closedAlerts", JSON.stringify(closedAlerts));

      closeAlert(item);
    });
  }
};

export default alerts;
